module.exports = __webpack_public_path__ + "components/MapControl/svg/Siedziba urzędu.svg?46a084b7";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Siedziba urzędu.svg
// module id = 2100
// module chunks = 0